import { styled, Grid, Button } from "@mui/material";

export const Container = styled(Grid)({
  padding: "20px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "20px",
});

export const CheckButton = styled(Button)({
  alignSelf: "center",
  width: "150px",
});
